var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraph3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "283px",
    height: "64px",
    viewBox: "0 0 283 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u66F2\u7EBF4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "2.6887907%",
    x2: "50%",
    y2: "91.698639%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C51FF",
    stopOpacity: 0.6,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C51FF",
    stopOpacity: 0.1,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875",
    transform: "translate(-1276.000000, -841.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6570\\u636E\\u533A",
    transform: "translate(360.000000, 745.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u77FF\\u6C60\\u8D28\\u62BC",
    transform: "translate(915.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-18",
    transform: "translate(0.000000, 96.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,43.7384753 L33.7011719,16.6305072 L75.5332031,28.3188575 L107.414063,18.1328606 L148.689453,33.1021442 L174.324219,18.1328606 L209.420547,13.2806063 L235.295419,28.296795 L264.759766,20.0928991 L285,2 L285,54 C285,59.5228475 280.522847,64 275,64 L10,64 C4.4771525,64 6.76353751e-16,59.5228475 0,54 L0,43.7384753 L0,43.7384753 Z",
    id: "\\u8DEF\\u5F84-3",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "\\u8DEF\\u5F84",
    stroke: "#8C51FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "2.24950267e-14 43.7384753 33.7011719 16.6305072 75.5332031 28.3188575 107.414063 18.1328606 148.689453 33.1021442 174.324219 18.1328606 209.420547 13.2806063 235.295419 28.296795 264.759766 20.0928991 285 2"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph3);
export default __webpack_public_path__ + "static/media/graph3.77e0e7cd6b8e5ac81c599c26609baf89.svg";
export { ForwardRef as ReactComponent };